import React, { useState } from 'react';
import './styles.css';
import { Box, InputLabel, TextField, ThemeProvider, createTheme, Button, Typography } from '@mui/material';
import CustomTextField from '../../components/CustomTextField';
import YenTextField from '../../components/YenTextField';
import CustomCurrencyTextField from '../../components/CustomCurrencyTextField';
import DateSelector from '../../components/DateSelector';
import SelectBox from '../../components/SelectBox';
import MultiSelectPrimary from '../../components/MultiSelectPrimary';
import { colors } from '../../common/pallette/colors';
import HistoryTable from '../../components/HistoryTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import EmploymentStatusSelect from '../../components/EmploymentStatusSelect';
import DepartmentAutocomplete from '../../components/DepartmentAutocomplete';
import RegisteredPositionAutoComplete from '../../components/RegisteredPositionAutoComplete';
import LeaderShipRolesAutocomplete from '../../components/LeaderShipRolesAutocomplete';
import QualificationsAutoComplete from '../../components/QualificationsAutoComplete';
import { useTranslation } from 'react-i18next';
import { formatDate, isEmpty } from '../../common/StaticExports';
import PeriodTable from '../../components/PeriodTable';
import ClubCareerTable from '../../components/ClubCareerTable';
import InternationalClubTable from '../../components/InternationalClubTable';

const theme = createTheme({
    components: {
        MuiStack: {
            styleOverrides: {
                root: {
                    paddingTop: '0px !important'
                }
            }
        }
    }
})

const competitionHead = [
    {
      key: '', displayName: 'Club Name',
    },
    {
        key: '', displayName: 'From year',
    },
    {
        key: '', displayName: 'To year',
    },
    {
        key: '', displayName: '',
    },
  ]

const coachingHead = [
{
    key: '', displayName: 'Club Name',
},
{
    key: '', displayName: 'From year',
},
{
    key: '', displayName: 'To year',
},
{
    key: '', displayName: '',
},
]

const AddPlayerForm = (props: any) => {
    const {onCancelClick, onAddClick} = props;

    const [addClubCareer, setAddClubCareer] = useState(false);
    const [addInternationalCareer, setAddInternationalCareer] = useState(false);
    const [addNewPeriod, setAddNewPeriod] = useState(false);
    const initialData = {
        "id": null,
        "name": "",
        "playerId": null,
        "dateOfBirth": null,
        "academyPeriods": [
            {
            "id": null,
            "dateFrom": null,
            "dateTo": null
            }
        ],
        "clubCareers": [
            {
            "id": null,
            "country": "",
            "club": "",
            "dateFrom": null,
            "dateTo": null
            }
        ],
        "internationalCareers": []
    };
    const [newPlayer, setNewPlayer]:any = useState(initialData);
    const [t] = useTranslation();
    
    const updateState = ((key:any, updatedData:any) => {
        const updatedStaff = {
            ...newPlayer,
            [key]: updatedData,
        };
        setNewPlayer(updatedStaff);
    });

    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Box className='mb20'>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                        <Typography className='standardsHeading uppercase'>{t('DC_8_ACADEMY_DETAILS')}</Typography>
                        <Box className='academyDetailsContainer'>
                            <CustomTextField label={t('DC_8_NAME')} value={newPlayer?.name} manageChange={(e:any) => {updateState('name', e)}} isError={isEmpty(newPlayer?.name)} errorMessage={t('REQUIRED')} />
                            <DateSelector label={t('DC_8_DATE_OF_BIRTH')} dateValue={newPlayer?.dateOfBirth ? formatDate(newPlayer?.dateOfBirth) : null} manageChange={(e:any) => {updateState('dateOfBirth', e)}} isError={isEmpty(newPlayer?.dateOfBirth)} errorMessage={t('REQUIRED')} />
                            <CustomTextField type={'number'} label={t('DC_8_ID')} value={newPlayer?.playerId} manageChange={(e:any) => {updateState('playerId', parseInt(e))}} />
                        </Box>
                        </Box>
                        <Box className='mb20 periodAtAcademyContainer'>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography className='standardsHeading uppercase'>{t('DC_8_PARIOD_AT_ACADEMY')}</Typography>
                            <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addNewPeriod} variant='contained' size='small' onClick={() => {setAddNewPeriod(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                {'Add another time period'}
                            </Button>
                        </Box>
                        <Box>
                            <PeriodTable
                            data={newPlayer?.academyPeriods ? newPlayer?.academyPeriods : []}
                            addData={addNewPeriod} 
                            handleClick={() => setAddNewPeriod(false)}
                            updateList={(e:any) => {updateState('academyPeriods', e)}} />
                        </Box>
                        </Box>
                    </Box>
                    
                    <Box className='mb20'>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography className='standardsHeading uppercase'>{t('DC_8_CLUB_CAREER')}</Typography>
                            <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addClubCareer} variant='contained' size='small' onClick={() => {setAddClubCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                {'Add another time period'}
                            </Button>
                        </Box>
                        <Box>
                        <ClubCareerTable
                        data={newPlayer?.clubCareers ? newPlayer?.clubCareers : []}
                        addData={addClubCareer} 
                        handleClick={() => setAddClubCareer(false)}
                        updateList={(e:any) => {updateState('clubCareers', e)}}/>
                        </Box>
                    </Box>
                    <Box className='mb20'>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography className='standardsHeading uppercase'>{t('DC_8_INTERNATIONAL_CAREER')}</Typography>
                            <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addInternationalCareer} variant='contained' size='small' onClick={() => {setAddInternationalCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                {'Add another time period'}
                            </Button>
                        </Box>
                        <Box>
                        <InternationalClubTable
                        data={newPlayer?.internationalCareers ? newPlayer?.internationalCareers : []}
                        addData={addInternationalCareer} 
                        handleClick={() => setAddInternationalCareer(false)}
                        updateList={(e:any) => {updateState('internationalCareers', e)}}/>
                        </Box>
                    </Box>
                    <Box sx={{ mt: 'auto', display: 'flex', ml: 'auto' }}>
                        <Button 
                        className='smallButton closeCancelButtonStyles' 
                        variant='contained' sx={{ mr: 2 }} 
                        disableElevation disableRipple 
                        onClick={() => {onCancelClick(); setNewPlayer(initialData);}}>
                            Cancel
                        </Button>
                        <Button
                         className='smallButton' 
                         variant='contained'
                         disableElevation 
                         disableRipple
                         onClick={() => {
                            onAddClick(newPlayer);
                            setNewPlayer(initialData);}}
                         >Add</Button>
                    </Box>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default AddPlayerForm;